import React from "react";
import { releaseAPI } from "../api/releaseAPI";
import { Button } from "react-bootstrap";

interface ReleaseFilesProps {
  releaseName: string;
}

function ReleaseFiles({ releaseName }: ReleaseFilesProps) {
  const downloadPackage = async () => {
    await releaseAPI.downloadReleasePackage(releaseName);
  };

  return <Button onClick={downloadPackage}>Download Release Package</Button>;
}

export default ReleaseFiles;
